// API Configuration - Update BASE_URL when backend port changes
const getApiBaseUrl = () => {
  console.log("BASE_URL:::", process.env.REACT_APP_BASE_URL)
  let url = process.env.REACT_APP_BASE_URL || 'http://172.16.116.148:8000/api';
  url = url.trim().replace(/\/+$/, '');
  return url;
};

const CONFIG = {
  API_BASE_URL: getApiBaseUrl(),
  PAGE_SIZE: 100,
  COLORS: {
    GDAM: '#27AE60',
    RTM: '#2E86C1',
    DAM: '#F39C12',
    DSM: '#E74C3C',
    FORECAST: '#2E86C1',
    ACTUAL: '#A04000',
    CONFIDENCE: '#82E0AA',
  },
};
export default CONFIG;